import RequestHistory from "../../modules/request-history/views/RequestHistory.vue";

const RequestHistoryRoutes = {
  path: "historico-solicitacoes",
  component: RequestHistory,
  meta: {
    requiresAuth: true,
  },
};

export default RequestHistoryRoutes;
